import { render } from "./MainListOfAccountsReceivablePayments.vue?vue&type=template&id=dcdb4c80&scoped=true"
import script from "./MainListOfAccountsReceivablePayments.vue?vue&type=script&lang=js"
export * from "./MainListOfAccountsReceivablePayments.vue?vue&type=script&lang=js"

import "./MainListOfAccountsReceivablePayments.vue?vue&type=style&index=0&id=dcdb4c80&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcdb4c80"]])

export default __exports__